import { IAchievementScoreCategoryRow } from './types'

export interface IAchievementScoreScores {
  financial: number | null
  sob: number | null
}

export const getAchievementScoreScores = (
  rows: IAchievementScoreCategoryRow[]
): IAchievementScoreScores => {
  const totalRow = rows.find((row) => row.isTotal)

  return {
    financial: totalRow?.financial.score ?? null,
    sob: totalRow?.sob.score ?? null,
  }
}
